import { render } from "./BuscarProducto.vue?vue&type=template&id=45374a7e&scoped=true"
import script from "./BuscarProducto.vue?vue&type=script&lang=js"
export * from "./BuscarProducto.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45374a7e"]])

export default __exports__